/**
 * Table cell renderer for multi-line, non-truncated string values.
 * @module WrappedStringCell
 */
import React from "react";

/** Props for {@link WrappedStringCell}. */
interface WrappedStringCellProps {
  /** Cell text shown with word wrapping enabled */
  value: any;
  [key: string]: any;
}

/**
 * Renders a string that wraps across multiple lines and is never truncated.
 *
 * Overrides the `white-space: nowrap` / `overflow: hidden` inherited from the
 * `.table-cell` wrapper via `whitespace-normal` and `break-words`.
 *
 * @param props - {@link WrappedStringCellProps}
 * @returns Wrapped string cell content
 */
export const WrappedStringCell: React.FC<WrappedStringCellProps> = ({
  value,
}) => {
  return (
    <div
      title={value}
      className="overflow-wrap-anywhere w-full whitespace-normal break-words"
    >
      {value}
    </div>
  );
};

export default WrappedStringCell;
